export default "/assets/images/icon-doller.svg?14bfa27d42169852d663991cf0b54a48";